import { mediaApi } from '@sitecore-jss/sitecore-jss-react';

export const convertSrcJss = (src: string, maxWidth: number = null, maxHeight: number = null) => {
  return mediaApi.updateImageUrl(src, { 'mw': String(maxWidth), 'mh': String(maxHeight) });
};

export const createSrcSet = (src: string, widths: number[]) => {
  return mediaApi.getSrcSet(src, widths.map(w => ({ 'mw': String(w) })));
};
